<div fxLayout="column" fxLayoutAlign="space-between start" fxFill>
  <div fxLayout="row" fxLayoutAlign="start center" class="header">
    <div class="header-text" fxFlex>
      {{'Activate_Module_Dialog_Title' | translate}}
    </div>
    <div fxFlex="30px"><mat-icon svgIcon="close" class="close-icon" (click)="onCloseClick()"></mat-icon></div>
  </div>
  <div style="width: 100%; height: 100%; padding-top: 2em;" fxLayout="column" fxLayoutAlign="start start">
    <div [innerHTML]="readAboutActivatingText"></div>
    <button fxFlex="nogrow" (click)="onConfirmationClick()" class="button button-with-top-margin">{{'Activate_Module_Confirm' | translate}}</button>
  </div>
</div>
